import { takeLatest } from 'typed-redux-saga';
import { workerErrorNotifyThunk } from 'utils/sagas';
import { actionReportDeltaLinkedMarketFetch } from './actions';

export const sagasReportDeltaLinkedMarket = [
  takeLatest(actionReportDeltaLinkedMarketFetch.rejected, workerErrorNotifyThunk),
];
